import { FC, Fragment } from 'react';

export interface Props {
   text: string;
   lineBreak?: string;
}

export const MultiLineText: FC<Props> = ({ text, lineBreak }) => {
   if (!lineBreak) return text;

   const lines = text.split(lineBreak);

   return lines.map((line, index) => (
      // eslint-disable-next-line @eslint-react/no-array-index-key
      <Fragment key={index}>
         {line}
         {index < lines.length - 1 && <br />}
      </Fragment>
   ));
};
